import DeleteKeyForm from './DeleteKeyForm'

export default DeleteKeyForm
